module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/institutions/icon_stethoscope-32bd4176814d439ce0c1f896eb6d948c.svg";